import { CalendarX } from 'lucide-react';
import { formatDate } from '@/lib/format';
import { cn } from '@/lib/utils';
import type { BlockedDate } from '@/api/blockedDates.api';

interface BlockedDateBannerProps {
  /** The block covering the selected visit date. */
  block: BlockedDate;
  /** The selected visit date (YYYY-MM-DD). */
  visitDate: string;
  className?: string;
}

/**
 * Inline notice shown while the selected visit date falls inside an
 * operator-blocked range. Every sell / proceed / pay entry point is disabled
 * alongside it; the cashier must pick another date.
 */
export function BlockedDateBanner({ block, visitDate, className }: BlockedDateBannerProps) {
  const range =
    block.dateFrom === block.dateTo
      ? formatDate(block.dateFrom)
      : `${formatDate(block.dateFrom)} – ${formatDate(block.dateTo)}`;

  return (
    <div
      role="alert"
      className={cn(
        'flex items-start gap-3 rounded-xl border-2 border-destructive/30 bg-destructive/5 px-4 py-3 text-sm',
        className,
      )}
    >
      <CalendarX className="mt-0.5 h-5 w-5 shrink-0 text-destructive" aria-hidden="true" />
      <div className="min-w-0">
        <p className="font-semibold text-destructive">
          Tanggal kunjungan {formatDate(visitDate)} ditutup — penjualan tidak tersedia.
        </p>
        <p className="mt-0.5 text-ink-700">
          {block.reason?.trim() ? (
            <>
              Alasan: <span className="font-medium text-ink-900">{block.reason.trim()}</span>
              {' · '}
            </>
          ) : null}
          Periode: <span className="tabular-nums">{range}</span>. Pilih tanggal kunjungan lain.
        </p>
      </div>
    </div>
  );
}
